// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false
};

export const firebaseConfig = {
  apiKey: "AIzaSyCzj6UUmBNg0erL5Re1k1cjvLaNxOH4XT8",
    authDomain: "autocomplete-demo-201811.firebaseapp.com",
    databaseURL: "https://autocomplete-demo-201811.firebaseio.com",
    projectId: "autocomplete-demo-201811",
    storageBucket: "autocomplete-demo-201811.appspot.com",
    messagingSenderId: "999551169192"
}


// WEBPACK FOOTER //
// ./src/environments/environment.ts